import { NgModule, APP_INITIALIZER } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { MatTableModule } from '@angular/material/table'
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatTooltipModule } from '@angular/material/tooltip';
import { NgIf } from '@angular/common';
import { MatInputModule } from '@angular/material/input';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS, MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatCardModule } from '@angular/material/card';
import { DatePipe } from '@angular/common';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatSortModule } from '@angular/material/sort';
import { FontAwesomeModule, FaIconLibrary } from '@fortawesome/angular-fontawesome';
import { faHeart } from '@fortawesome/free-solid-svg-icons';
import { faHeart as faHeartUnchecked } from '@fortawesome/free-regular-svg-icons';


import {
	DateAdapter, MAT_DATE_FORMATS,
	MAT_DATE_LOCALE,
} from '@angular/material/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

import { Config } from '../environments/config';

// figure out auth!!
// import { AuthInterceptor } from './auth/auth.interceptor';
import { ForbiddenInterceptor } from './interceptors/forbidden.interceptor';
// import { AppRoutingModule } from './app.routes';
// import { AuthGuardService } from './auth/auth-guard.service';
// import { SkipAuthGuard } from 'auth/skip-auth-guard.service';
// import { AuthService } from './auth/auth.service';

// modules

import { DashboardComponent } from './pages/dashboard/dashboard.component';
import { TopnavComponent } from './components/topnav/topnav.component';
import { FooterComponent } from './components/footer/footer.component';

import { MatSelectModule } from '@angular/material/select';
import { MatRadioModule } from '@angular/material/radio';
import { MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS } from '@angular/material-moment-adapter';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';

import { AuthorizeComponent } from './components/authorize/authorize.component';


import { NgxMaterialTimepickerModule } from 'ngx-material-timepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { ModalComponent } from './components/modal/modal.component';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { ChangePasswordComponent } from './components/changepassword/changepassword.component';
import { NoResultsComponent } from './components/no-results/no-results.component';
import { ForgotPasswordComponent } from './pages/forgot-password/forgot-password.component';

import { MatTabsModule } from '@angular/material/tabs';
import { PageNotFoundComponent } from './pages/page-not-found-component/page-not-found-component.component';


import { MatExpansionModule } from '@angular/material/expansion';

// import { CKEditorModule } from '@ckeditor/ckeditor5-angular';
import { BbLoginComponent } from './pages/bb-login/bb-login.component';
import { TopNavLoginComponent } from './components/top-nav-login/top-nav-login.component';
import { ResetPasswordComponent } from './pages/user/reset-password/reset-password.component';
import { ClipboardModule } from '@angular/cdk/clipboard';
import { OverlayModule } from '@angular/cdk/overlay';
import { EmailQueueListComponent } from './components/email-queue/email-queue-list/email-queue-list.component';
import { EmailQueueComponent } from './pages/email-queue/email-queue/email-queue.component';
import { EmailQueueViewComponent } from './pages/email-queue/email-queue-view/email-queue-view.component';
import { StatusBubbleComponent } from './components/status-bubble/status-bubble/status-bubble.component';
import { CreateUserComponent } from './pages/user/create-user/create-user.component';
import { UsersListComponent } from './pages/user/users-list/users-list.component';
import { EditUserComponent } from './pages/user/edit-user/edit-user.component';
import { DashboardBbprogramadministratorComponent } from './components/dashboard/dashboard-bbprogramadministrator/dashboard-bbprogramadministrator.component';
import { ActivateUserComponent } from './pages/user/activate-user/activate-user.component';
import { TranslatePipe } from './components/translate/translate.pipe';

import { TranslationService } from './services/translation.service';
import { MatFormField } from '@angular/material/form-field';
import { TagListComponent } from './pages/tags/tag-list/tag-list.component';
import { CreateTagComponent } from './pages/tags/create-tag/create-tag.component';
import { EditTagComponent } from './pages/tags/edit-tag/edit-tag.component';
import { ViewTagComponent } from './pages/tags/view-tag/view-tag.component';
import { AuditLogsComponent } from './components/audit-logs/audit-logs.component';
import { InformationPopupComponent } from './components/information-popup/information-popup.component';
import { AddMaterialComponent } from './pages/materials/add-material/add-material.component';
import { NgxDropzoneModule } from 'ngx-dropzone';
import { MaterialListComponent } from './pages/materials/material-list/material-list.component';
import { ViewMaterialComponent } from './pages/materials/view-material/view-material.component';
import { EditMaterialComponent } from './pages/materials/edit-material/edit-material.component';
import { AddCourseComponent } from './pages/course/add-course/add-course.component';
import { BulkImportComponent } from './pages/bulk-import/bulk-import.component';
import { CourseDetailsComponent } from './components/course/course-details/course-details.component';
import { CourseMaterialsComponent } from './components/course/course-materials/course-materials.component';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { CourseListComponent } from './pages/course/course-list/course-list.component';
import { ViewCourseComponent } from './pages/course/view-course/view-course.component';
import { EditCourseComponent } from './pages/course/edit-course/edit-course.component';
import { OrgFormComponent } from './components/organization/org-form/org-form.component';
import { AddOrgComponent } from './pages/organization/add-org/add-org.component';
import { OrgListComponent } from './pages/organization/org-list/org-list.component';
import { ViewOrgComponent } from './pages/organization/view-org/view-org.component';
import { EditOrgComponent } from './pages/organization/edit-org/edit-org.component';
import { CreateInviteBbComponent } from './pages/invitations/bb-invitations/create-invite-bb/create-invite-bb.component';
import { BbInvitationFormComponent } from './components/invitations/bb-invitations/bb-invitation-form/bb-invitation-form.component';
import { ViewBbInvitationsComponent } from './pages/invitations/bb-invitations/view-bb-invitations/view-bb-invitations.component';
import { BbInvitationListComponent } from './pages/invitations/bb-invitations/bb-invitation-list/bb-invitation-list.component';
import { EditBbInvitationComponent } from './pages/invitations/bb-invitations/edit-bb-invitation/edit-bb-invitation.component';
import { LlttfInvitationFormComponent } from './components/invitations/llttf-invitations/llttf-invitation-form/llttf-invitation-form.component';
import { CreateLlttfInviteComponent } from './pages/invitations/llttf-invitations/create-llttf-invite/create-llttf-invite.component';
import { LlttfInvitationListComponent } from './pages/invitations/llttf-invitations/llttf-invitation-list/llttf-invitation-list.component';
import { ViewLlttfInvitationsComponent } from './pages/invitations/llttf-invitations/view-llttf-invitations/view-llttf-invitations.component';
import { EditLlttfInvitationComponent } from './pages/invitations/llttf-invitations/edit-llttf-invitation/edit-llttf-invitation.component';
import { TopNavRegistrationComponent } from './components/top-nav-registration/top-nav-registration.component';
import { RegistrationFormComponent } from './components/registration-form/registration-form.component';
import { RegisterBbCoachedParticipantComponent } from './pages/user/register-participant/register-bb-coached-participant/register-bb-coached-participant.component';
import { AccessBbInvitationComponent } from './pages/invitations/bb-invitations/access-bb-invitation/access-bb-invitation.component';
import { AccountCreatedComponent } from './pages/user/register-participant/account-created/account-created.component';
import { AccessLlttfCohortComponent } from './pages/invitations/llttf-invitations/access-llttf-cohort/access-llttf-cohort.component';
import { LlttfEmailVerificationComponent } from './pages/invitations/llttf-invitations/llttf-email-verification/llttf-email-verification.component';
import { LlttfCheckEligibilityComponent } from './pages/invitations/llttf-invitations/llttf-check-eligibility/llttf-check-eligibility.component';
import { RegisterLlttfParticipantComponent } from './pages/user/register-participant/register-llttf-participant/register-llttf-participant.component';
import { AccessDeniedInvitationComponent } from './pages/invitations/access-denied-invitation/access-denied-invitation.component';
import { AccountExistsComponent } from './pages/user/register-participant/account-exists/account-exists.component';
import { BbSelfGuidedIntroComponent } from './pages/user/register-participant/register-bb-self-guided/bb-self-guided-intro/bb-self-guided-intro.component';
import { BbSelfGuidedRegistrationFirstStepComponent } from './pages/user/register-participant/register-bb-self-guided/bb-self-guided-registration-first-step/bb-self-guided-registration-first-step.component';
import { BbSelfGuidedAccessLinkComponent } from './pages/user/register-participant/register-bb-self-guided/bb-self-guided-access-link/bb-self-guided-access-link.component';
import { BbSelfGuidedFinalStepComponent } from './pages/user/register-participant/register-bb-self-guided/bb-self-guided-final-step/bb-self-guided-final-step.component';
import { ViewUserComponent } from './pages/user/view-user/view-user.component';
import { EditUserFormComponent } from './components/users/edit-user-form/edit-user-form.component';
import { UserSpecialPermissionComponent } from './components/users/user-special-permission/user-special-permission.component';
import { UserRecommendedSessionComponent } from './components/users/user-recommended-session/user-recommended-session.component';
import { UserCourseListComponent } from './components/users/user-course-list/user-course-list.component';
// import { CKEditorModule } from 'ckeditor4-angular';
import { FroalaEditorModule, FroalaViewModule } from 'angular-froala-wysiwyg';
import { DashboardParticipantComponent } from './pages/participants/dashboard-participant/dashboard-participant.component';
import { MoodCheckinComponent } from './components/participants/mood/mood-checkin/mood-checkin.component';
import { GettingStartedComponent } from './components/participants/getting-started/getting-started.component';

import { CourseListingComponent } from './components/participants/course-listing/course-listing.component';
import { CoursesComponent } from './pages/participants/courses/courses.component';
import { AddPlanComponent } from './pages/participants/plans/add-plan/add-plan.component';
import { ViewPlanComponent } from './pages/participants/plans/view-plan/view-plan.component';
import { ClosePlanComponent } from './pages/participants/plans/close-plan/close-plan.component';
import { OpenCourseComponent } from './pages/participants/courses/open-course/open-course.component';
import { MoodModalDataComponent } from './components/participants/mood/mood-modal-data/mood-modal-data.component';
import { ViewCourseParticipantComponent } from './pages/participants/courses/view-course-participant/view-course-participant.component';
import { PdfViewerComponent } from './components/participants/pdf-viewer/pdf-viewer.component';
import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';
import { PlanDetailsFormComponent } from './components/participants/plans/plan-details-form/plan-details-form.component';
import { PlansRemindersComponent } from './components/participants/plans/plans-reminders/plans-reminders.component';
import { EditPlanComponent } from './pages/participants/plans/edit-plan/edit-plan.component';
import { NeedHelpComponent } from './components/participants/need-help/need-help.component';
import { ParticipantProfileComponent } from './pages/participants/participant-profile/participant-profile.component';
import { UserProfileComponent } from './components/users/user-profile/user-profile.component';
import { EditProfileFormComponent } from './components/users/edit-profile-form/edit-profile-form.component';
import { EditParticipantProfileComponent } from './pages/participants/edit-participant-profile/edit-participant-profile.component';
import { AdminProfileComponent } from './pages/user/admin-profile/admin-profile.component';
import { EditAdminProfileComponent } from './pages/user/edit-admin-profile/edit-admin-profile.component';
import { NoteComponent } from './components/participants/note/note.component';
import { NoteFormComponent } from './components/participants/note/note-form/note-form.component';
import { TagsComponent } from './components/participants/tags/tags.component';
import { FavouriteCourseComponent } from './components/participants/favourite-course/favourite-course.component';
import { CourseEnrollmentStatusComponent } from './components/participants/course-enrollment-status/course-enrollment-status.component';
import { RetiredCourseComponent } from './components/participants/retired-course/retired-course.component';
import { CourseCardComponent } from './components/participants/course-card/course-card.component';
import { ApplicationVersionService } from './services/application-version.service';
import { ViewClosePlanComponent } from './pages/participants/plans/view-close-plan/view-close-plan.component';
import { RouterLinkActive } from '@angular/router';
import { ParticipantExtractrComponent } from './components/reporting/participant-extractr/participant-extractr.component';
import { CourseExtractComponent } from './components/reporting/course-extract/course-extract.component';

import { DashboardCoachBranchadminComponent } from './components/dashboard/dashboard-coach-branchadmin/dashboard-coach-branchadmin.component';
import { DashboardDataAnalysisComponent } from './components/dashboard/dashboard-data-analysis/dashboard-data-analysis.component';
import { DashboardDevadminComponent } from './components/dashboard/dashboard-devadmin/dashboard-devadmin.component';
import { AboutUsComponent } from './pages/about-us/about-us.component';
import { ContactUsComponent } from './pages/contact-us/contact-us.component';
import { PrivacyPolicyComponent } from './pages/privacy-policy/privacy-policy.component';
import { RoleOnboardingListComponent } from './pages/role-onboarding/role-onboarding-list/role-onboarding-list.component';
import { CreateRoleOnboardingComponent } from './pages/role-onboarding/create-role-onboarding/create-role-onboarding.component';
import { EditRoleOnboardingComponent } from './pages/role-onboarding/edit-role-onboarding/edit-role-onboarding.component';
import { ViewRoleOnboardingComponent } from './pages/role-onboarding/view-role-onboarding/view-role-onboarding.component';
import { CompleteOnboardingComponent } from './pages/role-onboarding/complete-onboarding/complete-onboarding.component';
import { MyTrainingComponent } from './pages/role-onboarding/my-training/my-training.component';




const MY_DATE_FORMAT = {
	parse: {
		dateInput: 'DD/MM/yyyy', // this is how your date will be parsed from Input
	},
	display: {
		dateInput: 'DD/MM/yyyy', // this is how your date will get displayed on the Input
		monthYearLabel: 'MMMM YYYY',
		dateA11yLabel: 'LL',
		monthYearA11yLabel: 'MMMM YYYY',
	},
};

@NgModule({ declarations: [
        AppComponent,
        DashboardComponent,
        FooterComponent,
        AuthorizeComponent,
        ModalComponent,
        ChangePasswordComponent,
        NoResultsComponent,
        ForgotPasswordComponent,
        PageNotFoundComponent,
        BbLoginComponent,
        TopNavLoginComponent,
        ResetPasswordComponent,
        EmailQueueListComponent,
        EmailQueueComponent,
        EmailQueueViewComponent,
        StatusBubbleComponent,
        CreateUserComponent,
        UsersListComponent,
        EditUserComponent,
        DashboardBbprogramadministratorComponent,
        ActivateUserComponent,
        TranslatePipe,
        TagListComponent,
        CreateTagComponent,
        EditTagComponent,
        ViewTagComponent,
        AuditLogsComponent,
        InformationPopupComponent,
        AddMaterialComponent,
        BulkImportComponent,
        MaterialListComponent,
        ViewMaterialComponent,
        EditMaterialComponent,
        AddCourseComponent,
        CourseDetailsComponent,
        CourseMaterialsComponent,
        CourseListComponent,
        ViewCourseComponent,
        EditCourseComponent,
        OrgFormComponent,
        AddOrgComponent,
        OrgListComponent,
        ViewOrgComponent,
        EditOrgComponent,
        CreateInviteBbComponent,
        BbInvitationFormComponent,
        ViewBbInvitationsComponent,
        BbInvitationListComponent,
        EditBbInvitationComponent,
        LlttfInvitationFormComponent,
        CreateLlttfInviteComponent,
        LlttfInvitationListComponent,
        ViewLlttfInvitationsComponent,
        EditLlttfInvitationComponent,
        TopNavRegistrationComponent,
        RegistrationFormComponent,
        RegisterBbCoachedParticipantComponent,
        AccessBbInvitationComponent,
        AccountCreatedComponent,
        AccessLlttfCohortComponent,
        LlttfEmailVerificationComponent,
        LlttfCheckEligibilityComponent,
        RegisterLlttfParticipantComponent,
        AccessDeniedInvitationComponent,
        AccountExistsComponent,
        BbSelfGuidedIntroComponent,
        BbSelfGuidedRegistrationFirstStepComponent,
        BbSelfGuidedAccessLinkComponent,
        BbSelfGuidedFinalStepComponent,
        ViewUserComponent,
        EditUserFormComponent,
        UserSpecialPermissionComponent,
        UserRecommendedSessionComponent,
        UserCourseListComponent,
        DashboardParticipantComponent,
        MoodCheckinComponent,
        GettingStartedComponent,
        PlansRemindersComponent,
        CourseListingComponent,
        CoursesComponent,
        AddPlanComponent,
        ViewPlanComponent,
        ClosePlanComponent,
        OpenCourseComponent,
        MoodModalDataComponent,
        ViewCourseParticipantComponent,
        PlanDetailsFormComponent,
        EditPlanComponent,
        PdfViewerComponent,
        NeedHelpComponent,
        ParticipantProfileComponent,
        UserProfileComponent,
        EditProfileFormComponent,
        EditParticipantProfileComponent,
        AdminProfileComponent,
        EditAdminProfileComponent,
        NoteComponent,
        NoteFormComponent,
        TagsComponent,
        FavouriteCourseComponent,
        CourseEnrollmentStatusComponent,
        RetiredCourseComponent,
        CourseCardComponent,
        ViewClosePlanComponent,
        ParticipantExtractrComponent,
        CourseExtractComponent,
        DashboardCoachBranchadminComponent,
        DashboardDevadminComponent,
        DashboardDataAnalysisComponent,
        AboutUsComponent,
        ContactUsComponent,
        PrivacyPolicyComponent,
        RoleOnboardingListComponent,
        CreateRoleOnboardingComponent,
        EditRoleOnboardingComponent,
        ViewRoleOnboardingComponent,
        CompleteOnboardingComponent,
        MyTrainingComponent,
    ],
    bootstrap: [AppComponent], imports: [BrowserModule,
        RouterLinkActive,
        AppRoutingModule,
        FormsModule,
        ReactiveFormsModule,
        MatTableModule,
        MatSortModule,
        MatToolbarModule,
        MatPaginatorModule,
        MatTooltipModule,
        TopnavComponent,
        MatFormFieldModule,
        MatInputModule,
        MatIconModule,
        BrowserAnimationsModule,
        NgIf,
        MatCardModule,
        MatDatepickerModule,
        MatSelectModule,
        MatRadioModule,
        MatNativeDateModule,
        NgxMaterialTimepickerModule,
        MatDialogModule,
        DatePipe,
        MatSnackBarModule,
        MatAutocompleteModule,
        MatTabsModule,
        MatExpansionModule,
        //  CKEditorModule,
        ClipboardModule,
        OverlayModule,
        MatSelectModule,
        NgxDropzoneModule,
        MatCheckboxModule,
        FroalaEditorModule,
        FroalaViewModule,
        FontAwesomeModule,
        NgxExtendedPdfViewerModule], providers: [
        DatePipe,
        MatSnackBarModule,
        TranslationService,
        ApplicationVersionService,
        TranslatePipe,
        // figure out auth!!
        // {
        // 	provide: HTTP_INTERCEPTORS,
        // 	useClass: AuthInterceptor,
        // 	multi: true
        // },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: ForbiddenInterceptor,
            multi: true
        },
        {
            provide: APP_INITIALIZER,
            useFactory: initializeApp,
            deps: [Config],
            multi: true,
        },
        // {
        // 	provide: APP_BASE_HREF,
        // 	useValue: '/',
        // },
        Config,
        // { provide: NGX_MAT_MOMENT_DATE_ADAPTER_OPTIONS, useValue: { useUtc: true } },
        { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS] },
        { provide: MAT_DATE_FORMATS, useValue: MY_DATE_FORMAT },
        { provide: MAT_FORM_FIELD_DEFAULT_OPTIONS, useValue: { hideRequiredMarker: true, floatLabel: 'always', appearance: 'outline' } },
        provideHttpClient(withInterceptorsFromDi()),
    ] })

export class AppModule {
  constructor(library: FaIconLibrary) {
    library.addIcons(
      faHeart,
      faHeartUnchecked
    );
  }
}

export function initializeApp(config: Config) {
	return (): Promise<any> => {
		return config.Init();
	};
}

